import { ReactNode } from "react"

export default function FunnelLayout({
  children,
  header,
}: {
  children: ReactNode
  header?: ReactNode
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-vm-cream text-vm-ink">
      {header}
      <main className="vm-container flex grow flex-col">{children}</main>
    </div>
  )
}
